<!-- Lista aplicações -->
<p class="text-center" ng-show="applications && !applications.length && !loadingAplicacoes">
  <small>Nenhum tratamento de semente...</small>
</p>

<span class="input-group-addon no-border no-background" ng-show="loadingAplicacoes">
  <i class="fa fa-spinner fa-spin"></i>
</span>

<uib-accordion id="list-application-history" ng-show="applications.length">
  <div infinite-scroll="getApplications()"
       infinite-scroll-parent="true"
       infinite-scroll-disabled="rightSide != 'applications'">
    <div ng-repeat="application in applications | filter:applicationStatusFilter" class="card-list">
      <uib-accordion-group id="{{getCardApplicationId(application)}}" class="panel-default panel-aplicacoes aplicacoes-bg" is-open="application.open">
        <uib-accordion-heading>
          <div prevent-event>
            <h3>
              <strong>{{::application.item_estoque_origem.descricao}}</strong>
              &raquo;
              <strong>{{::application.item_estoque_destino.descricao}}</strong>
              <ng-include src="'status-icons.html'"></ng-include>
            </h3>
            <div class="float-data" ng-include="'data-ts.html'"></div>
          </div>

          <div class="arrow-expand-card text-cinza" ng-show="!application.loading">
            <span ng-hide="application.open">
              ver mais&nbsp;
              <i class="glyphicon pointer glyphicon-chevron-down"></i>
            </span>
            <span ng-show="application.open">
              ver menos&nbsp;
              <i class="glyphicon pointer glyphicon-chevron-up"></i>
            </span>
          </div>

          <div class="clearfix"></div>
        </uib-accordion-heading>

        <p>
          <span ng-show="application.usuario">
            Usuário: <strong>{{::application.usuario.nome_completo | capitalize}}</strong>
            <br>
          </span>

          <span ng-show="application.data_hora_inicio">
            Iniciada em <strong>{{::application.data_hora_inicio | date:'dd/MM'}}</strong>
            <br>
          </span>

          <span ng-show="application.data_hora_fim">
            Encerrada em <strong>{{::application.data_hora_fim | date:'dd/MM'}}</strong>
            <br>
          </span>
          <span ng-show="application.tratamento">
            <b>{{application.tratamento}}</b>
            <br>
          </span>
        </p>

        <table class="table-card">
          <thead>
            <tr>
              <th>Produto</th>
              <th class="text-right">Quantidade</th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="produto in application.itens track by $index" class="f-size-11">
              <td class="vertical-middle padding-bottom-5">
                {{::produto.item_estoque.descricao}}
              </td>
              <td class="vertical-middle text-right padding-left-5 padding-bottom-5">
                {{::produto.quantidade | number:2}} {{::produto.unidade.abreviatura}}
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Impressão -->
        <span ng-print print-element-id="print-ts-{{application.id}}">
          <button type="button" class="btn-xs btn-link text-info" ng-click="appWrap.preparePrint(application, $event)">
            <i class="fa fa-print" ng-hide="application.loadingRecommendation"></i>
            <i class="fa fa-spinner fa-pulse fa-fw" ng-show="application.loadingRecommendation"></i>
            Imprimir aplicação
          </button>
        </span>
        <ng-include src="'views/painel_propriedade/print_ts.html'"></ng-include>
      </uib-accordion-group>

      <p class="left-border-card">
        <span class="pointer" ng-show="application.open" ng-click="openRecommendationDetail(application)">
          ver recomendação
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </span>
      </p>

      <div id="{{getSubCardApplicationId(application)}}" class="subcard-recommendation subcard-left panel-heading" ng-show="isOpened(application)">
        <p class="left-border-card">
          <span class="pointer" ng-click="openRecommendationDetail(application)">
            esconder
            <i class="fa fa-chevron-up" aria-hidden="true"></i>
          </span>
        </p>

        <div>
          <h3 class="text-center">Recomendação</h3>

          <div class="text-center" ng-show="application.loadingRecommendation">
            <i class="fa fa-spinner fa-pulse fa-fw"></i>
          </div>

          <h5 class="text-center" ng-show="!application.loadingRecommendation && !application.recommendation.id">
            Nenhuma recomendação vinculada
          </h5>

          <div ng-show="!application.loadingRecommendation && application.recommendation.id">
            <p>
              Recomendante: <strong>{{::(application.recommendation.recomendante || application.recommendation.usuario).nome_completo | capitalize}}</strong>
            </p>

            <table class="table-card">
              <thead>
                <tr>
                  <th>Produto</th>
                  <th class="text-right">Dose</th>
                  <th class="text-right">Total</th>
                  <th class="text-right">Aplicado</th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="produto in getRecommendationProducts(application) track by $index" class="f-size-11">
                  <td class="vertical-middle padding-bottom-5">
                    {{::((produto.produto || produto).descricao || (produtos.produto || produto).id)}}
                  </td>
                  <td class="vertical-middle text-right padding-left-5 padding-bottom-5">
                    {{::(produto.dose || produto.qt_dose) | number:2}} {{::produto.unidade.abreviatura | lowercase}}/{{getUnidade(application) | lowercase}}
                  </td>
                  <td class="vertical-middle text-right padding-left-5 padding-bottom-5">
                    {{::getQuantidadeTotal(application, produto) | number:2}} {{::produto.unidade.abreviatura | lowercase}}/{{application.item_estoque_destino.unidade.abreviatura | lowercase}}
                  </td>
                  <td class="vertical-middle text-right padding-left-5 padding-bottom-5">
                    {{::application.insumosRecomendacao[$index].aplicado | number:1}}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</uib-accordion>
<!-- Fim lista recomendacoes-->
